import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { IOrgForm } from '@/types/org.d';
import api from '@/api/question';
import plubicApi from '@/api/public';

@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '课后作业 - 模态框 -',
    component: 'org/manage/components/bModal',
  };

  public form: any = {
  }

  private loading: boolean = false;

  public quesTypes: any = [];

  public courseTypes: any = [];

  public knowledges: any = [];

  public diffculites: any = [];

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    orgTitle: [
      { required: true, message: '机构名称不能为空' },
    ],
    loginName: [
      { required: true, message: '登录名称不能为空' },
    ],
  };

  mounted() {
    plubicApi.getType('question').then((res: any) => {
      this.quesTypes = res;
    });
    plubicApi.getType('knowledge').then((res: any) => {
      this.knowledges = res;
    });
    plubicApi.getType('difficulty').then((res: any) => {
      this.diffculites = res;
    });
    plubicApi.getCourseType().then((res: any) => {
      this.courseTypes = res;
    });
  }

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        if (title.includes('编辑')) {
          api.editHomeWork(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addHomeWork(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
